import React, { useState } from 'react';

import Form from '../../style-components/Form/Form.jsx';
import DatePicker from '../../style-components/Form/DatePicker.jsx';
import { patchCourseLearnunit } from '../../models/learnunits.js';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
};

const EditCourseLearnunit = ({ courseLearnunit, setOpen }) => {

  const [formState, setFormState] = useState({
    starting_date: courseLearnunit.starting_date,
    ending_date: courseLearnunit.ending_date,
  });

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    const response = await patchCourseLearnunit(courseLearnunit.id, formState);
    if (response.status === 200) {
      alert('Unidad de aprendizaje editada con éxito.');
      setOpen(false);
      window.location.reload();
    } else {
      alert('Error al editar la unidad de aprendizaje, intente de nuevo.');
    }
    setLoading(false);
  }

  return (
    <div style={styles.container}>
      <Form title='Editar unidad de aprendizaje' onSubmit={handleSubmit} onClose={() => setOpen(false)} loading={loading}>
        <DatePicker
          name='starting_date'
          value={formState.starting_date}
          setFormState={setFormState}
          label='Fecha de inicio'
          maxDate={formState.ending_date}
        />
        <DatePicker
          name='ending_date'
          value={formState.ending_date}
          setFormState={setFormState}
          label='Fecha de término'
          minDate={formState.starting_date}
        />
      </Form>
    </div>
  )
};

export default EditCourseLearnunit;